import React, { useEffect, useState } from "react";
import { DropdownAppAction } from "../../../../widget/common/ui/Dropdown";
import { ChatsContextImport } from "../../../../provider/chats/chats/chats/ChatsContextProvider";
import { AlertConfirm } from "../../../../widget/common/ui/Alerts";
import { TeamChatsContextImport } from "../../../../provider/chats/chats/team_chats/TeamChatsContextProvider";
import SocketChatsKeys from "../../../../const/SocketChatsKeys";
import { useDispatch } from "react-redux";
import { addModal } from "../../../../libraries/state_reducers/widget/ModalsReducer";
import ModalKeys from "../../../../const/ModalKeys";
import { ResponsiveDeviceType } from "../../../../widget/layouts/ScreenMedia";
import { IconNormal } from "../../../../widget/common/ui/Icon";
import AppTheme from "../../../../service/app_config/AppTheme";
import { DepartmentChatsContextImport } from "../../../../provider/chats/chats/department_chats/DepartmentChatsContextProvider";
import { TeamResults } from "../../../../model/chats/TeamConversationDetailsModel";
import { DepartmentResults } from "../../../../model/chats/DepartmentConversationDetailsModel";
import { GroupChatsContextImport } from "../../../../provider/chats/chats/group_chats/GroupChatsContextProvider";
import { useSelector } from "react-redux";
import { RootState } from "../../../../libraries/state_reducers/store";
import { GroupResults } from "../../../../model/chats/GroupConversationDetailsModel";
import { MuteSettingsType } from "../../../../libraries/types_interface/chats/ChatsTypes";
import UtilityHelper from "../../../../service/utilities/UtilityHelper";
import {
  updateDepartmentMuteSettings,
  updateGroupMuteSettings,
  updateTeamMuteSettings,
} from "../../../../libraries/state_reducers/chats/ChatsReducer";
import { setARFFormType } from "../../../../libraries/state_reducers/chats/ARFReducer";

// 1-team, 2-dept, 3-group

const ConversationActions = () => {
  const type: number = ResponsiveDeviceType();

  const dispatch = useDispatch();

  const { chatSelected, sidebarShowHide } = ChatsContextImport();
  const teamChatsContextImport = TeamChatsContextImport();
  const departmentChatsContextImport = DepartmentChatsContextImport();
  const groupChatsContextImport = GroupChatsContextImport();

  const flag: string = chatSelected?.flag! ?? "0";

  const conversationDetailGroupSelector = useSelector(
    (state: RootState) => state.chats.conversationDetailGroup
  );

  ////////////////////////////////////////////////////////////////////////
  //  TEAM
  ////////////////////////////////////////////////////////////////////////
  const [teamConversationDetail, setTeamConversationDetail] =
    useState<TeamResults>(teamChatsContextImport.conversationDetail!);

  const [teamMuteSettings, setTeamMuteSettings] = useState<MuteSettingsType>(
    teamChatsContextImport.muteSettings!
  );

  useEffect(() => {
    if (
      teamChatsContextImport.muteSettings! != null &&
      ["1", "4"].includes(flag)
    ) {
      setTeamMuteSettings(teamChatsContextImport.muteSettings!);
    }
    // eslint-disable-next-line
  }, [teamChatsContextImport.muteSettings!, flag]);

  useEffect(() => {
    if (
      teamChatsContextImport.conversationDetail != null &&
      ["1", "4"].includes(flag)
    ) {
      setTeamConversationDetail(teamChatsContextImport.conversationDetail!);
    }
  }, [teamChatsContextImport.conversationDetail, flag]);

  ////////////////////////////////////////////////////////////////////////
  //  DEPARTMENT
  ////////////////////////////////////////////////////////////////////////
  const [departmentConversationDetail, setDepartmentConversationDetail] =
    useState<DepartmentResults>(
      departmentChatsContextImport.conversationDetail!
    );

  const [departmentMuteSettings, setDepartmentTeamMuteSettings] =
    useState<MuteSettingsType>(departmentChatsContextImport.muteSettings!);

  useEffect(() => {
    if (departmentChatsContextImport.muteSettings! != null && flag === "2") {
      setDepartmentTeamMuteSettings(departmentChatsContextImport.muteSettings!);
    }
    // eslint-disable-next-line
  }, [departmentChatsContextImport.muteSettings!, flag]);

  useEffect(() => {
    if (
      departmentChatsContextImport.conversationDetail != null &&
      flag === "2"
    ) {
      setDepartmentConversationDetail(
        departmentChatsContextImport.conversationDetail!
      );
    }
  }, [departmentChatsContextImport.conversationDetail, flag]);

  ////////////////////////////////////////////////////////////////////////
  //  GROUP
  ////////////////////////////////////////////////////////////////////////
  const [groupConversationDetail, setGroupConversationDetail] =
    useState<GroupResults>(groupChatsContextImport.conversationDetail!);

  const [groupMuteSettings, setGroupMuteSettings] = useState<MuteSettingsType>(
    groupChatsContextImport.muteSettings!
  );

  useEffect(() => {
    if (groupChatsContextImport.muteSettings! != null && flag === "3") {
      setGroupMuteSettings(groupChatsContextImport.muteSettings!);
    }
    // eslint-disable-next-line
  }, [groupChatsContextImport.muteSettings!, flag]);

  useEffect(() => {
    if (groupChatsContextImport.conversationDetail != null && flag === "3") {
      setGroupConversationDetail(groupChatsContextImport.conversationDetail!);
    }
  }, [groupChatsContextImport.conversationDetail, flag]);

  useEffect(() => {
    if (conversationDetailGroupSelector != null && flag === "3") {
      setGroupConversationDetail(conversationDetailGroupSelector);
    }
    // eslint-disable-next-line
  }, [conversationDetailGroupSelector]);

  ////////////////////////////////////////////////////////////////////////

  // FUNCTIONS
  const handleMedia = () => {
    if (type === 3) {
      sidebarShowHide(true, "media");
    } else {
      dispatch(
        addModal({
          id: ModalKeys.chat_media,
          title: "media",
          size: "lg",
          screenMobileView: type === 3 ? false : true,
        })
      );
    }
  };

  const handleClearChat = () => {
    AlertConfirm({
      title: "are_you_sure_you_wish_to_clear_the_chat",
      onConfirm: async () => {
        if (["1", "4"].includes(flag)) {
          teamChatsContextImport.updateConversationSettings({
            convId: chatSelected?.conv_id!,
            eventName: SocketChatsKeys.chat_clear_messages,
          });
        } else if (flag === "2") {
          departmentChatsContextImport.updateConversationSettings({
            convId: chatSelected?.conv_id!,
            eventName: SocketChatsKeys.chat_clear_messages,
          });
        } else if (flag === "3") {
          groupChatsContextImport.updateConversationSettings({
            convId: chatSelected?.conv_id!,
            eventName: SocketChatsKeys.chat_clear_messages,
          });
        }
      },
    });
  };

  const handleBlock = () => {
    AlertConfirm({
      title: ["1", "4"].includes(flag)
        ? (teamConversationDetail?.conv_settings?.block_details
            ?.my_block_status ?? "0") === "0"
          ? "are_you_sure_to_block_this_user"
          : "are_you_sure_to_unblock_this_user"
        : (departmentConversationDetail?.conv_settings?.block_details
            ?.my_block_status ?? "0") === "0"
        ? "are_you_sure_to_block_this_user"
        : "are_you_sure_to_unblock_this_user",
      onConfirm: async () => {
        if (["1", "4"].includes(flag)) {
          teamChatsContextImport.updateConversationSettings({
            convId: chatSelected?.conv_id!,
            eventName: SocketChatsKeys.chat_block_profile,
            profileId:
              teamConversationDetail?.participant_details?.account_id! ?? "0",
            blockStatus:
              (teamConversationDetail?.conv_settings?.block_details
                ?.my_block_status ?? "0") === "0"
                ? "1"
                : "0",
          });
        } else if (flag === "2") {
          departmentChatsContextImport.updateConversationSettings({
            convId: chatSelected?.conv_id!,
            eventName: SocketChatsKeys.chat_block_profile,
            profileId: departmentConversationDetail?.owner_account_id ?? "0",
            blockStatus:
              (departmentConversationDetail?.conv_settings?.block_details
                ?.my_block_status ?? "0") === "0"
                ? "1"
                : "0",
          });
        }
      },
    });
  };

  const handleMuteNotification = () => {
    dispatch(
      addModal({
        id: ModalKeys.chat_mute_notification,
        title: "mute_notification",
        size: "md",
      })
    );

    if (["1", "4"].includes(flag)) {
      dispatch(
        updateTeamMuteSettings(
          teamConversationDetail?.conv_settings?.muted_conversations!
        )
      );
    } else if (flag === "2") {
      dispatch(
        updateDepartmentMuteSettings(
          departmentConversationDetail?.conv_settings?.muted_conversations!
        )
      );
    } else if (flag === "3") {
      dispatch(
        updateGroupMuteSettings(
          groupConversationDetail?.conv_settings?.muted_conversations!
        )
      );
    }
  };

  const handleReport = () => {
    dispatch(
      addModal({
        id: ModalKeys.chat_report,
        title: "report",
        size: "lg",
        allowBottomSheet: true,
      })
    );
  };

  const handleSaveMessages = () => {
    dispatch(
      addModal({ id: ModalKeys.chat_work_my_messages, allowBottomSheet: true })
    );
  };

  const handleExit = () => {
    dispatch(
      addModal({
        id: ModalKeys.chat_group_exit,
        allowBottomSheet: true,
        size: "md",
      })
    );
  };

  const handleClickARF = () => {
    if (departmentConversationDetail != null) {
      dispatch(
        setARFFormType(
          departmentConversationDetail?.form_status! as "1" | "2" | "3"
        )
      );
      dispatch(
        addModal({
          id: ModalKeys.arf_form,
          size: "lg",
          title: UtilityHelper.ARFLabel(
            departmentConversationDetail?.form_status!
          ),
          screenMobileView: type === 3 ? false : true,
        })
      );
    }
  };

  // TEAM / DEPATMENT
  let defaultOption: Array<{
    title: string;
    subTitle?: string;
    onClick: () => void;
  }> = [
    {
      title: "media",
      onClick: handleMedia,
    },
    {
      title: "saved_messages",
      onClick: handleSaveMessages,
    },
    {
      title: ["1", "4"].includes(flag)
        ? (teamConversationDetail?.conv_settings?.block_details
            ?.my_block_status ?? "0") === "1"
          ? "unblock"
          : "block"
        : flag === "2"
        ? (departmentConversationDetail?.conv_settings?.block_details
            ?.my_block_status ?? "0") === "1"
          ? "unblock"
          : "block"
        : "block", //unblock
      onClick: handleBlock,
    },
    {
      title: "mute_notification",
      subTitle:
        ["1", "4"].includes(flag) && teamMuteSettings != null
          ? teamMuteSettings?.muteStatus === "0"
            ? undefined
            : UtilityHelper.isNotEmpty(teamMuteSettings.muteEnd)
            ? `until ${teamMuteSettings.muteEnd}`
            : "always"
          : flag === "2" && departmentMuteSettings != null
          ? departmentMuteSettings?.muteStatus === "0"
            ? undefined
            : UtilityHelper.isNotEmpty(departmentMuteSettings.muteEnd)
            ? `until ${departmentMuteSettings.muteEnd}`
            : "always"
          : undefined,
      onClick: handleMuteNotification,
    },
    {
      title: "clear_chat",
      onClick: handleClearChat,
    },
    {
      title: "report",
      onClick: handleReport,
    },
  ];

  // GROUP
  if (flag === "3") {
    defaultOption = [
      {
        title: "group_info",
        onClick: () => {
          if (type === 3) {
            sidebarShowHide(true, "group_info");
          } else {
            dispatch(
              addModal({
                id: ModalKeys.chat_group_info,
                title: "group_info",
                size: "lg",
                screenMobileView: type === 3 ? false : true,
              })
            );
          }
        },
      },
      {
        title: "media",
        onClick: handleMedia,
      },
      {
        title: "mute_notification",
        subTitle:
          groupMuteSettings != null
            ? groupMuteSettings?.muteStatus === "0"
              ? undefined
              : UtilityHelper.isNotEmpty(groupMuteSettings.muteEnd)
              ? `until ${groupMuteSettings.muteEnd}`
              : "always"
            : undefined,
        onClick: handleMuteNotification,
      },
      {
        title: "clear_chat",
        onClick: handleClearChat,
      },
      {
        title: "exit_group",
        onClick: handleExit,
      },

      {
        title: "report",
        onClick: handleReport,
      },
    ];

    if (
      groupConversationDetail != null &&
      groupConversationDetail.status === "0"
    ) {
      defaultOption = defaultOption.filter(
        (item) =>
          !["mute_notification", "clear_chat", "exit_group"].includes(
            item.title
          )
      );
    }
  }

  return (
    <>
      {flag === "2" &&
        departmentConversationDetail != null &&
        departmentConversationDetail?.call_status! !== "0" && (
          <a href={`tel:${departmentConversationDetail?.call_status!}`}>
            <IconNormal name="call_icon" color={AppTheme.themeFont} />
          </a>
        )}
      {flag === "2" &&
        departmentConversationDetail != null &&
        departmentConversationDetail?.form_status! !== "0" && (
          <IconNormal
            name="form_icon"
            color={AppTheme.themeFont}
            handleClick={() => handleClickARF()}
          />
        )}

      {Number(flag) > 0 && (
        <DropdownAppAction icon="menu_list" options={defaultOption} />
      )}
    </>
  );
};

export default ConversationActions;
